import * as React from 'react';
import Svg, {ClipPath, Defs, G, Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function ViewTermsCondition() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <G clipPath="url(#clip0_5677_438)">
        <Path
          d="M8.167 19.313a.554.554 0 01-.542-.563V5.25c0-.31.244-.563.542-.563h5.416V7.5c0 .622.484 1.125 1.084 1.125h2.708V18.75c0 .31-.244.563-.542.563H8.167zM8.167 3C6.972 3 6 4.009 6 5.25v13.5C6 19.991 6.972 21 8.167 21h8.666C18.028 21 19 19.991 19 18.75V8.432c0-.598-.227-1.171-.633-1.593L15.3 3.657A2.12 2.12 0 0013.77 3H8.167zm1.896 9c-.45 0-.813.376-.813.844 0 .467.362.844.813.844h4.874c.45 0 .813-.377.813-.844 0-.468-.362-.844-.813-.844h-4.874zm0 3.375c-.45 0-.813.376-.813.844 0 .467.362.843.813.843h4.874c.45 0 .813-.376.813-.843 0-.468-.362-.844-.813-.844h-4.874z"
          fill={Styles.Colors.PayNew.black01}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_5677_438">
          <Path
            fill={Styles.Colors.PayNew.white01}
            transform="translate(6 3)"
            d="M0 0H13V18H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

const ViewTermsConditionIcon = React.memo(ViewTermsCondition);

export default ViewTermsConditionIcon;
